<template>
	<div>
		<svg
			:width="iconSize"
			:height="iconSize"
			viewBox="0 0 25 25"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M16.4062 5.46875C18.1321 5.46875 19.5312 6.86786 19.5312 8.59375M22.6562 8.59375C22.6562 12.0455 19.858 14.8438 16.4062 14.8438C16.0409 14.8438 15.6829 14.8124 15.3347 14.7522C14.7482 14.6509 14.1271 14.7791 13.7063 15.2L10.9375 17.9688H8.59375V20.3125H6.25V22.6562H2.34375V19.7208C2.34375 19.0992 2.59068 18.5031 3.03022 18.0635L9.8 11.2937C10.2209 10.8729 10.3491 10.2518 10.2478 9.66532C10.1876 9.31715 10.1562 8.95911 10.1562 8.59375C10.1562 5.14197 12.9545 2.34375 16.4062 2.34375C19.858 2.34375 22.6562 5.14197 22.6562 8.59375Z"
				:stroke="color"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</svg>
	</div>
</template>

<script>
export default {
	name: 'IconSvgKey',
	props: {
		color: {
			type: String,
			default: '#000000',
		},
		size: {
			type: Number,
			default: null,
		},
	},
	computed: {
		iconSize() {
			return this.size ? `${this.size}px` : '44px'
		},
	},
}
</script>

<style scoped></style>
